import React from 'react'

import {
  ExploreCategory,
  exploreCategories,
} from 'tripPlanner/pages/trip/Explore/common'
import { PlaceGeo } from 'tripPlanner/types/common'

// Create a context for storing and updating the selected place and category for explore
const ExploreQueryContext = React.createContext<{
  query: string | undefined
  locationBias: [number, number] | undefined
  place: PlaceGeo | undefined
  category: ExploreCategory
  setPlace: (place: PlaceGeo) => void
  setCategory: (category: ExploreCategory) => void
}>({
  query: undefined,
  locationBias: undefined,
  place: undefined,
  category: exploreCategories[0],
  setPlace: () => {},
  setCategory: () => {},
})

export default ExploreQueryContext
